import { Component, EventEmitter, Input, Output } from '@angular/core';

// Holiday registration/editing modal.
@Component({
  selector: 'holidays-modal',
  templateUrl: './holidays-modal.component.html',
  styleUrls: ['./holidays-modal.component.css'],
})
export class HolidaysModalComponent {
  @Input() years: any = [];
  @Input() holidays: any;

  @Output() yearChanged = new EventEmitter<any>();
  @Output() addRequested = new EventEmitter<void>();
  @Output() deleteRequested = new EventEmitter<any>();
}
